// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qj_a bhj_su bhj_kv bhj_kw","PostDetailRight__brandDaysPosts":"qj_b bhj_su bhj_kv bhj_kw"};